import React, { useState, useEffect } from 'react';
import styles from './CookieConsent.module.scss';

const CookieConsent = () => {
  const [visible, setVisible] = useState(false);
  const [isClosing, setIsClosing] = useState(false);

  useEffect(() => {
    const hasConsent = document.cookie
      .split('; ')
      .some(row => row.startsWith('user_consent='));
    
    if (!hasConsent) {
      setVisible(true);
    }
  }, []);

  // ═══════════════════════════════════════════════
  // ФУНКЦИЯ ЗАГРУЗКИ МЕТРИКИ ПОСЛЕ СОГЛАСИЯ
  // ═══════════════════════════════════════════════
  const loadAnalytics = () => {
    const scripts = document.querySelectorAll('script[data-tilda-cookie-type="analytics"]');
    
    scripts.forEach(script => {
      const newScript = document.createElement('script');
      
      for (const attr of script.attributes) {
        if (attr.name !== 'type') {
          newScript.setAttribute(attr.name, attr.value);
        }
      }
      
      if (script.dataset.src) {
        newScript.src = script.dataset.src;
      }
      
      newScript.textContent = script.textContent;
      newScript.type = 'text/javascript';
      script.parentNode.replaceChild(newScript, script);
    });

    console.log('✅ Яндекс.Метрика активирована');
  };

  // ═══════════════════════════════════════════════
  // ОБРАБОТЧИКИ КНОПОК С АНИМАЦИЕЙ УХОДА ВЛЕВО
  // ═══════════════════════════════════════════════
  const handleAccept = () => {
    // Запускаем анимацию закрытия
    setIsClosing(true);
    
    // Через 0.5 секунд (после анимации) выполняем действия
    setTimeout(() => {
      document.cookie = 'user_consent=accepted; path=/; max-age=31536000';
      setVisible(false);
      loadAnalytics();
    }, 500);
  };

  const handleDecline = () => {
    // Запускаем анимацию закрытия
    setIsClosing(true);
    
    // Через 0.5 секунд (после анимации) выполняем действия
    setTimeout(() => {
      document.cookie = 'user_consent=declined; path=/; max-age=31536000';
      setVisible(false);
      console.log('❌ Пользователь отказался от аналитики');
    }, 500);
  };

  if (!visible) return null;

  return (
    <div className={`${styles.overlay} ${isClosing ? styles.closing : ''}`}>
      <div className={`${styles.banner} ${isClosing ? styles.bannerClosing : ''}`}>
        <p className={styles.text}>
          <span className={styles.icon}>
            {/* Ваша иконка самбо */}
            <svg viewBox="0 0 100 100" width="22" height="22">
              <circle cx="35" cy="22" r="9" fill="#ff0000"/>
              <rect x="28" y="30" width="14" height="22" rx="3" fill="#f52525"/>
              <rect x="22" y="36" width="8" height="5" rx="2" fill="#ffffff"/>
              <rect x="40" y="36" width="8" height="5" rx="2" fill="#ffffff"/>
              <rect x="30" y="50" width="5" height="16" rx="2" fill="#e94560"/>
              <rect x="37" y="50" width="5" height="16" rx="2" fill="#e94560"/>
              <circle cx="65" cy="22" r="9" fill="#1a1a8e"/>
              <rect x="58" y="30" width="14" height="22" rx="3" fill="#1a1a8e"/>
              <rect x="52" y="36" width="8" height="5" rx="2" fill="#e94560"/>
              <rect x="70" y="36" width="8" height="5" rx="2" fill="#ff0000"/>
              <rect x="60" y="50" width="5" height="16" rx="2" fill="#1a1a8e"/>
              <rect x="67" y="50" width="5" height="16" rx="2" fill="#1a1a8e"/>
              <ellipse cx="50" cy="68" rx="35" ry="6" fill="none" stroke="#ffd700" strokeWidth="1.5" strokeDasharray="3,3"/>
            </svg>
          </span>
          Мы используем файлы cookie для улучшения работы сайта. 
          Подробнее в{' '}
          <a href="/documents/privacy-policy.pdf" className={styles.link} target="_blank">
            Политике конфиденциальности
          </a>
        </p>
        <div className={styles.buttons}>
          <button className={styles.decline} onClick={handleDecline}>
            Только необходимое
          </button>
          <button className={styles.accept} onClick={handleAccept}>
            Принять все
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookieConsent;